"use strict";

/**
 * Load video from the HTML with `data-onload="js:FlixVideo.setup||12345` statement
 * 
 * @method FlixVideo.getViewCount()
 * @see FlixVideo.setup to start debugging
 * @event flix:video:ready
 * @example document.addEventListener('flix:video:ready', (e) => onPlayerReady(e.detail.player, e.detail.vid));
 */
var FlixVideo = function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var FlixVideo = {};
  var vid = null;
  var player = null;
  var started = false;
  var viewCountKey = 'video_view_count_session';

  function onPageLoad() {
    // Clear Plyr instance when we visit non-video page (and reset on video page)
    FlixVideo.clearPlayer();
    vid = null;
    /** Clear Plyr for pre-rolls as well (and check first that it's loaded - not blocked by adblock) */

    if (typeof FlixPreroll != 'undefined') {
      FlixPreroll.clearPlayer();
    } // Check that it's a page with video placeholder that should
    // be replaced with video player


    var el = document.querySelector('#video-player-placeholder');

    if (!el) {
      return;
    }

    vid = el.getAttribute('data-vid');

    if (!vid) {
      FlixStats.increment('video_setup_vid_is_empty');
      return;
    }

    if (typeof Plyr === 'undefined') {
      // if user has slow connection and plyr script not loaded yet
      document.addEventListener('flix:plyr', function () {
        return FlixVideo.setup(vid);
      });
    } else {
      FlixVideo.setup(vid);
    }
  }
  /**
   * Setup HTML video container.
   * Show preroll if needed.
   * 
   * @param {int} videoId 
   */


  FlixVideo.setup = function (videoId) {
    FlixUtils.request(Flix.urlLangPrefix + '/ajax/video-player/' + videoId, {
      responseType: 'json'
    }).then(function (data) {
      // if (Flix.routeArgs.vid != videoId) {
      //     // if user went to another video before previous one is loaded
      //     throw new Error(`videoId "${videoId}" is not from this video`);
      // }
      if (data.success) {
        started = false; // reset variable

        FlixVideo.clearPlayer();
        document.querySelector('#video-player-placeholder').insertAdjacentHTML('afterend', data.html);
        /** If url contains "?play=1" then video or preroll started automatically */

        var autoPlay = window.location.search.indexOf('play=1') != -1;

        if (FlixPreroll.isShouldShow()) {
          FlixPreroll.show(autoPlay);
        } else {
          FlixVideo.initPlayer(autoPlay);
        }
      } else {
        FlixModal.openWithUrl(Flix.urlLangPrefix + '/bot-check', 'GET', 'Robot check');
      }
    })["catch"](function (err) {
      if (Flix.isLocal()) {
        console.error(err);
      }

      FlixErrorLogger.log(err, 'video_ajax');
    });
  };
  /**
   * Also invoked in init.js for cases when it's not a video page and `setupPlayer()` not called
   */


  FlixVideo.clearPlayer = function () {
    if (typeof Plyr != 'undefined' && player instanceof Plyr) {
      player.destroy();
      player = null;
    }
  };
  /**
   * All logic that happens when video `play` event triggered
   * @param {Event} e 
   */


  function onPlay(e) {
    if (typeof ageverif !== 'undefined') {
      console.log('Age verification check on video play : ' + ageverifForceverify);

      if (ageverif.requiresVerification && !ageverif.verified || ageverifForceverify) {
        player.pause();
        Flix.ads.enabled = false;
        ageverif.start({
          closable: true,
          forceVerification: ageverifForceverify
        });
        return;
      }
    }

    if (!started) {
      started = true; // Update view counter

      sessionStorage.setItem(viewCountKey, FlixVideo.getViewCount() + 1); // Add video to history and update num views

      FlixUtils.request(Flix.urlLangPrefix + '/ajax/on-video-play/' + vid, {
        method: 'POST'
      })["catch"](function (err) {
        console.error(err);
        FlixErrorLogger.log(err, 'video_on_play');
      });
    }
  }

  ;
  /**
   * API method to call from other places
   */

  FlixVideo.playVideo = function () {
    if (player) {
      player.play();
    }
  };
  /**
   * Initialize Plyr instance
   * @param {boolean} autoPlay if video should start playing after initialization
   */


  FlixVideo.initPlayer = function () {
    var autoPlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var videoPlayerEl = document.querySelector('#video-player');
    var mosaicBaseUrl = videoPlayerEl === null || videoPlayerEl === void 0 ? void 0 : videoPlayerEl.getAttribute('data-mosaic');
    player = new Plyr('#video-player', {
      controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'settings', 'airplay', 'fullscreen'],
      settings: ['quality'],
      keyboard: {
        focused: true,
        global: true
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true,
        container: null
      },
      duration: videoPlayerEl === null || videoPlayerEl === void 0 ? void 0 : videoPlayerEl.getAttribute('data-duration'),
      previewThumbnails: {
        enabled: true,
        src: getVttThumbs(mosaicBaseUrl)
      }
    });
    player.speed = 1;
    player.on('play', onPlay);
    player.on('ready', function () {
      var _document$querySelect, _document$querySelect2;

      (_document$querySelect = document.querySelector('#video-player-placeholder')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('d-none');
      (_document$querySelect2 = document.querySelector('#video-player')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove('d-none');
      document.dispatchEvent(new CustomEvent('flix:video:ready', {
        detail: {
          player: player,
          vid: vid
        }
      }));

      if (autoPlay) {
        player.play();
      }
    });
  };
  /**
   * Return number of video views during this session
   * @returns int
   */


  FlixVideo.getViewCount = function () {
    var counter = parseInt(sessionStorage.getItem(viewCountKey));
    return isNaN(counter) ? 0 : counter;
  };

  var vttCache = {};

  function getVttThumbs(mosaicBaseUrl) {
    var videoPlayerEl = document.querySelector('#video-player');
    var duration = parseFloat(videoPlayerEl === null || videoPlayerEl === void 0 ? void 0 : videoPlayerEl.getAttribute('data-duration'));
    if (!duration || isNaN(duration)) return '';
    var cacheKey = "".concat(mosaicBaseUrl, "|").concat(duration);
    if (vttCache[cacheKey]) return vttCache[cacheKey];
    var vtt = 'WEBVTT\n\n';

    if (Flix.site === 'empflix') {
      // Empflix: 30 thumbs, 1.jpg to 30.jpg
      var totalThumbs = 30;
      var interval = duration / totalThumbs;

      for (var i = 1; i <= totalThumbs; i++) {
        var start = (i - 1) * interval;
        var end = Math.min(start + interval, duration);

        var timeFormat = function timeFormat(s) {
          return new Date(s * 1000).toISOString().substr(11, 12);
        };

        vtt += "".concat(timeFormat(start), " --> ").concat(timeFormat(end), "\n");
        vtt += (mosaicBaseUrl === null || mosaicBaseUrl === void 0 ? void 0 : mosaicBaseUrl.replace('#', i)) + '\n\n';
      }
    } else {
      // Tnaflix: sprite logic
      var thumbsPerSprite = 25;
      var columns = 5;
      var thumbWidth = 200;
      var thumbHeight = 100; // Dynamic algorithm (matches Python compute_dynamic_thumbs)

      var numThumbs;

      if (duration < 600) {
        numThumbs = 75;
      } else if (duration > 5000) {
        numThumbs = 500;
      } else {
        numThumbs = Math.floor((duration - 600) * 425 / 4400 + 75);
      }

      var _totalThumbs = numThumbs;
      var spriteCount = Math.ceil(_totalThumbs / thumbsPerSprite);

      var _interval = duration / _totalThumbs;

      var thumbIndex = 0;

      for (var sprite = 0; sprite < spriteCount; sprite++) {
        var url = mosaicBaseUrl === null || mosaicBaseUrl === void 0 ? void 0 : mosaicBaseUrl.replace('#', sprite);

        for (var _i = 0; _i < thumbsPerSprite && thumbIndex < _totalThumbs; _i++, thumbIndex++) {
          var _start = thumbIndex * _interval;

          var _end = Math.min(_start + _interval, duration);

          var col = _i % columns;
          var row = Math.floor(_i / columns);
          var x = col * thumbWidth;
          var y = row * thumbHeight;

          var _timeFormat = function _timeFormat(s) {
            return new Date(s * 1000).toISOString().substr(11, 12);
          };

          vtt += "".concat(_timeFormat(_start), " --> ").concat(_timeFormat(_end), "\n");
          vtt += "".concat(url, "#xywh=").concat(x, ",").concat(y, ",").concat(thumbWidth, ",").concat(thumbHeight, "\n\n");
        }
      }
    }

    var blobUrl = URL.createObjectURL(new Blob([vtt], {
      type: 'text/vtt'
    }));
    vttCache[cacheKey] = blobUrl;
    return blobUrl;
  }

  return FlixVideo;
}();